import Segment from 'components/Segment/Segment'
import React from 'react'
import styled from 'styled-components'
import Tooltip from 'components/Tooltip'

import { Wrapper, Input, TooltipShortcut } from './NavigationSelector.styles'

interface BaseItem<T> {
  label: string
  value: T
  shortcut?: string
}

interface IconItem<T> extends BaseItem<T> {
  type: 'icon'
  icon: React.ElementType
}

interface TextItem<T> extends BaseItem<T> {
  type: 'text'
}

export type Item<T> = IconItem<T> | TextItem<T>

interface NavigationSelectorProps<T> {
  className?: string
  disabled?: boolean

  name: string
  items: Item<T>[]

  onChange?: (item: Item<T>) => void
  selected?: string
}

const NavigationSelector = styled(function NavigationSelectorProps<
  T extends string
>(props: NavigationSelectorProps<T>) {
  const { className, disabled, name, items, onChange, selected } = props

  return (
    <Wrapper className={className} disabled={disabled}>
      <legend className="sr-only">{name}</legend>
      {items.map((item, index) => (
        <label key={index} tabIndex={item.value === selected ? undefined : 0}>
          <Tooltip
            placement="bottom-end"
            content={
              <>
                View as {item.value.toLowerCase()}
                {item.shortcut && (
                  <TooltipShortcut>Press {item.shortcut}</TooltipShortcut>
                )}
              </>
            }>
            <Input
              className="sr-only"
              name={name}
              value={item.value}
              type="radio"
              onChange={() => onChange?.(item)}
              checked={item.value === selected}
            />
            <Segment
              type={item.type}
              label={item.label}
              icon={item.type === 'icon' ? item.icon : undefined}
              active={item.value === selected}
            />
          </Tooltip>
        </label>
      ))}
    </Wrapper>
  )
})``

export default NavigationSelector
